import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebExperts,
  EcommerceWebProjects,
  EcommerceWebGoodfirms,
  WebClutchRatingLogo,
  WebAppIndustryRating,
} from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

const Ratingusa = () => {
  return (
    <div
      className="rating_usa rating_web_dev tekrevol_dark_bg rating_dubai rating_on_demand p-100"
      style={{ background: "#0B314D" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-md-4 mb-0"
          >
            <div className="rating_box">
              <div className="rating-svg">{WebAppIndustryRating}</div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  10+
                </div>
                <p>Years of Industry Experience</p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={3}
            xxl={3}
            className="mb-xl-0 mb-md-4 mb-0 ps-xl-4"
          >
            <div className="rating_box">
              <div className="rating-svg">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/app_dev_dubai.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={96}
                  height={95}
                />
              </div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  300+
                </div>
                <p>PWA developers</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="ps-xl-4">
            <div className="rating_box">
              <div className="rating-svg">{EcommerceWebExperts}</div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  1000+
                </div>
                <p>Successful App Delivered</p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="ps-xl-4">
            <div className="rating_box">
              <div className="rating-svg">{WebClutchRatingLogo}</div>
              <div className="rating-content">
                <div className="rating-num" style={{ color: "#fff" }}>
                  90%
                </div>
                <p>Client Retention Rate</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Ratingusa;
